export function getServiceUri(state) {
  return state.serviceUri;
}